import React, { FC, ReactNode } from 'react';
import { IonItem, IonIcon, IonLabel } from '@ionic/react';
import { chevronDownOutline, chevronForwardOutline } from 'ionicons/icons';

export interface AllieMenuAccordionProps {
  isOpen: boolean;
  onToggle: () => void;
  title: string;
  children?: ReactNode;
  className?: string;
  level?: number;
  iosIcon?: string;
  mdIcon?: string;
  customIcon?: React.ReactNode;
  disabled?: boolean;
  'data-testid'?: string;
}

/**
 * AllieMenuAccordion - Accordion component for menu items
 * Provides expandable/collapsible menu sections
 */
export const AllieMenuAccordion: FC<AllieMenuAccordionProps> = ({
  isOpen,
  onToggle,
  title,
  children,
  className,
  level = 0,
  iosIcon,
  mdIcon,
  customIcon,
  disabled = false,
  'data-testid': dataTestId,
}) => {
  const renderIcon = () => {
    if (customIcon) {
      return customIcon;
    }
    if (iosIcon && mdIcon) {
      return <IonIcon slot="start" ios={iosIcon} md={mdIcon} />;
    }
    return null;
  };

  return (
    <>
      <IonItem
        className={`menu-link-group accordion-level-${level} typography 
          ${level === 0 ? 'menu-margin' : ''} ${className || ''}`}
        button
        onClick={onToggle}
        disabled={disabled}
        mode="md"
        data-testid={dataTestId}
      >
        {renderIcon()}

        <IonLabel color="light" className="menu-link-group">
          {title}
        </IonLabel>

        <IonIcon slot="end" icon={isOpen ? chevronDownOutline : chevronForwardOutline} />
      </IonItem>

      {isOpen && children}
    </>
  );
};

AllieMenuAccordion.displayName = 'AllieMenuAccordion';
